import { useContext } from 'react';
import { MeterReadingDetails, Modal } from '@components';
import { ModalContext } from '@context';

import styles from './../modals.module.scss';

export const ReadingModal = () => {
	const {
		selectedDeviceReading: selectedReading,
		showReadingModal,
		setShowReadingModal,
	} = useContext(ModalContext);

	return selectedReading ? (
		<Modal
			customModalStyle={styles['modal']}
			open={showReadingModal}
			closeable
			handleClose={() => setShowReadingModal(false)}
		>
			<MeterReadingDetails />
		</Modal>
	) : (
		<></>
	);
};
